import React from 'react';
import { Checkbox, Space, Divider, Form, Typography } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const { Title, Paragraph } = Typography;

const ContactMethod = () => {
  const atLeastOneValueIsSelected = (_, value) =>
    value?.length
      ? Promise.resolve()
      : Promise.reject(
          new Error(
            getTranslatedString(
              'landlordPortal.applicationManagement.inviteLeadToApply.contactMethod.selectAtLeastOneContactMethod'
            )
          )
        );

  return (
    <>
      <Divider />
      <Title level={5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.contactMethod'
        )}
      </Title>
      <Paragraph>
        {getTranslatedString(
          'landlordPortal.applicationManagement.inviteLeadToApply.contactMethod.subtitle'
        )}
      </Paragraph>
      <Form.Item name="contact_methods" rules={[{ validator: atLeastOneValueIsSelected }]}>
        <Checkbox.Group>
          <Space direction="vertical">
            <Checkbox value="use_sms">SMS</Checkbox>
            <Checkbox value="use_email">Email</Checkbox>
          </Space>
        </Checkbox.Group>
      </Form.Item>
    </>
  );
};

ContactMethod.propTypes = {};

export { ContactMethod };
